/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "fulfillment": {
        "nested": {
          "behaviors": {
            "nested": {
              "common": {
                "nested": {
                  "Coordinates": {
                    "fields": {
                      "latitude": {
                        "type": "double",
                        "id": 1,
                        "rule": "optional"
                      },
                      "longitude": {
                        "type": "double",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Distance": {
                    "fields": {
                      "value": {
                        "type": "double",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unit": {
                        "type": ".squareup.fulfillment.behaviors.common.Distance.Unit",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Unit": {
                        "values": {
                          "DISTANCE_UNIT_UNSPECIFIED": 0,
                          "DISTANCE_UNIT_METERS": 1,
                          "DISTANCE_UNIT_KILOMETERS": 2,
                          "DISTANCE_UNIT_MILES": 3
                        }
                      }
                    }
                  },
                  "GeographicArea": {
                    "fields": {
                      "clientAreaIdentifier": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "defaultLabel": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "areaType": {
                        "type": ".squareup.fulfillment.behaviors.common.GeographicArea.AreaType",
                        "id": 3,
                        "rule": "optional"
                      },
                      "postalCodes": {
                        "type": ".squareup.fulfillment.behaviors.common.GeographicArea.PostalCodeArea",
                        "id": 4
                      },
                      "radius": {
                        "type": ".squareup.fulfillment.behaviors.common.GeographicArea.RadiusArea",
                        "id": 5
                      }
                    },
                    "nested": {
                      "AreaType": {
                        "values": {
                          "AREA_TYPE_DO_NOT_USE": 0,
                          "AREA_TYPE_POSTAL_CODE_LIST": 1,
                          "AREA_TYPE_RADIUS": 2
                        }
                      },
                      "PostalCodeArea": {
                        "fields": {
                          "includedPostalCodes": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "RadiusArea": {
                        "fields": {
                          "center": {
                            "type": ".squareup.fulfillment.behaviors.common.Coordinates",
                            "id": 1,
                            "rule": "optional"
                          },
                          "radius": {
                            "type": ".squareup.fulfillment.behaviors.common.Distance",
                            "id": 2,
                            "rule": "optional"
                          },
                          "minimumRadius": {
                            "type": ".squareup.fulfillment.behaviors.common.Distance",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "area": {
                        "oneof": ["postalCodes", "radius"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Coordinates && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Distance && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Distance?.nested?.Unit && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.GeographicArea && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.GeographicArea?.nested?.AreaType && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.GeographicArea?.nested?.PostalCodeArea && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.GeographicArea?.nested?.RadiusArea) {
  $root.addJSON(jsonData);
}

/**
 * Geographic coordinates representing a point on Earth.
 * Uses the WGS84 coordinate system (same as GPS).
 *
 * SOURCE Coordinates @ squareup/fulfillment/behaviors/common/geographic.proto at 12:1
 */
export const Coordinates = $root.lookupType('squareup.fulfillment.behaviors.common.Coordinates');
fixType(Coordinates);
Builder.createAndAttachToType(Coordinates);
/**
 * Distance measurement with a specified unit.
 * Used for delivery radius calculations, distance-based fees, and geographic constraints.
 *
 * SOURCE Distance @ squareup/fulfillment/behaviors/common/geographic.proto at 32:1
 */
export const Distance = $root.lookupType('squareup.fulfillment.behaviors.common.Distance');
fixType(Distance);
Builder.createAndAttachToType(Distance);
/**
 * Units of distance measurement.
 *
 * SOURCE Unit @ squareup/fulfillment/behaviors/common/geographic.proto at 36:3
 */
Distance.Unit = $root.lookupEnum('squareup.fulfillment.behaviors.common.Distance.Unit').values;
/**
 * Geographic area definition with support for postal code lists and radius-based areas.
 * Used to define delivery zones, fee application areas, and eligibility constraints.
 *
 * SOURCE GeographicArea @ squareup/fulfillment/behaviors/common/geographic.proto at 64:1
 */
export const GeographicArea = $root.lookupType('squareup.fulfillment.behaviors.common.GeographicArea');
fixType(GeographicArea);
Builder.createAndAttachToType(GeographicArea);
/**
 * Type of geographic area definition.
 *
 * SOURCE AreaType @ squareup/fulfillment/behaviors/common/geographic.proto at 68:3
 */
GeographicArea.AreaType = $root.lookupEnum('squareup.fulfillment.behaviors.common.GeographicArea.AreaType').values;
/**
 * Geographic area defined by an explicit list of postal/zip codes.
 * Useful for cities with irregular boundaries or specific neighborhood targeting.
 *
 * SOURCE PostalCodeArea @ squareup/fulfillment/behaviors/common/geographic.proto at 81:3
 */
GeographicArea.PostalCodeArea = $root.lookupType('squareup.fulfillment.behaviors.common.GeographicArea.PostalCodeArea');
fixType(GeographicArea.PostalCodeArea);
Builder.createAndAttachToType(GeographicArea.PostalCodeArea);
/**
 * Geographic area defined by a radius from a center point.
 * Supports both simple circular areas and donut-shaped areas (with minimum radius).
 * Useful for distance-based delivery zones.
 *
 * SOURCE RadiusArea @ squareup/fulfillment/behaviors/common/geographic.proto at 97:3
 */
GeographicArea.RadiusArea = $root.lookupType('squareup.fulfillment.behaviors.common.GeographicArea.RadiusArea');
fixType(GeographicArea.RadiusArea);
Builder.createAndAttachToType(GeographicArea.RadiusArea);